import * as yup from 'yup'

import constants from 'constants/index'

const { NAME_MAX_LENGTH, DESCRIPTION_MAX_LENGTH } = constants.privacyByDesign

// Na criação o departamento e o questionário são obrigatórios; na edição eles já
// estão definidos e o campo é apenas informativo. O responsável é um usuário da
// organização no app e um nome livre no portal de convidados.
const schema = ({ mode = 'new', responsibleField = 'user' } = {}) =>
  yup.object({
    name: yup.string().max(NAME_MAX_LENGTH).required(),
    description: yup.string().max(DESCRIPTION_MAX_LENGTH).required(),
    ...(responsibleField === 'user'
      ? { responsibleUserId: yup.string().nullable() }
      : { responsibleName: yup.string().max(NAME_MAX_LENGTH).nullable() }),
    ...(mode === 'new' && {
      departmentId: yup.string().required(),
      quizTemplateId: yup.string().required(),
    }),
  })

export default schema
